var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceBtnRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9107 3.57757C7.23614 3.25214 7.76378 3.25214 8.08922 3.57757L13.9225 9.41091C14.248 9.73634 14.248 10.264 13.9225 10.5894L8.08922 16.4228C7.76378 16.7482 7.23614 16.7482 6.9107 16.4228C6.58527 16.0973 6.58527 15.5697 6.9107 15.2442L12.1548 10.0002L6.9107 4.75609C6.58527 4.43065 6.58527 3.90301 6.9107 3.57757Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceBtnRight);
export default __webpack_public_path__ + "static/media/service-btn-right.51dadf5e201b41a2812bcd92cd189b78.svg";
export { ForwardRef as ReactComponent };